<!-- eslint-disable max-len -->
<template lang="pug">
.total-page
  van-form.feedback-container()
    div 您好，感谢您参加此次调研～
    div 哈啰将基于您的反馈持续优化搜索体验。
    div.lable-title(v-if="pageScene==='search_result'")
      span.red-star *
      span  请问您本次搜索更符合以下哪种情况?
    van-field.van-rate(v-if="pageScene==='search_result'" name="rate" label="" label-align="top")
      template(#input)
        div
          van-radio-group(v-model="form.suitableIndex"
            v-for="(item,index) in searchResultValueList")
            van-radio.from-check(:name="item.index") {{item.value}}
    van-field.van-rate(v-if="pageScene==='search_result'&&form.suitableIndex==='2'"
    name="rate" label="" label-align="top")
      template(#input)
        van-field.border-color(v-model="form.satisfiedStatement"
        placeholder="说点什么吧" maxlength="100")
    div.lable-title
      span.red-star *
      span(v-if="pageScene==='duaring_search'") 请问您对当前搜索推荐的词满意吗?
      span(v-if="pageScene==='search_sug'") 请问您对当前搜索联想词满意吗？
      span(v-if="pageScene==='search_result'") 请问您对当前搜索结果满意吗？
    van-field.van-rate(name="score" label="")
      template(#input)
        van-rate(
          v-model="form.score"
          :size="25"
          color="#ffd21e"
          void-icon="star"
          void-color="#eee"
          @change="onChangeRate"
          )

    // 搜索结果
    div.lable-title(v-if="form.score>4&&pageScene==='search_result'")
      span.red-star *
      span 请问您本次搜索时，最满意的地方是?
    van-field.van-rate(v-if="form.score>4&&pageScene==='search_result'"
    name="rate" label="" label-align="top")
      template(#input)
        div
          van-checkbox-group(v-model="form.satisfiedIndex"
          v-for="(item,index) in searchResultGoodList")
            van-checkbox.from-check(:name="item.index" shape="square") {{item.value}}
    van-field.van-rate(
    v-if="pageScene==='search_result'&&gOther(searchResultGoodList,form.satisfiedIndex)&&form.score>4"
    name="rate" label="" )
      template(#input)
        van-field.border-color(v-model="form.otherDissatisfiedStatement"
        placeholder="说点什么吧" maxlength="100")
    div.lable-title(v-if="form.score<=4&&pageScene==='search_result'")
      span.red-star *
      span 请问您本次搜索时，有哪些不满意的地方？
    van-field.van-rate(v-if="form.score<=4&&pageScene==='search_result'"
    name="rate" label="" label-align="top")
      template(#input)
        div
          van-checkbox-group(v-model="form.dissatisfiedIndex"
          v-for="(item,index) in searchResultBadList")
            van-checkbox.from-check(:name="item.index" shape="square") {{item.value}}
    van-field.van-rate(
    v-if="pageScene==='search_result'&&gOther(searchResultBadList,form.dissatisfiedIndex)&&form.score<=4"
    name="rate" label="" )
      template(#input)
        van-field.border-color(v-model="form.otherDissatisfiedStatement"
        placeholder="说点什么吧" maxlength="100")

    // 搜索中
    div.lable-title(v-if="pageScene==='duaring_search'")
      span 您想反馈哪个模块的问题:
    van-field.van-rate(v-if="pageScene==='duaring_search'" name="rate" label="" label-align="top")
      template(#input)
        van-radio-group(v-model="form.feedbackModule" @change="changeFeedbackModule")
          van-radio.from-check(name="0") 搜索框推荐词
          van-radio.from-check(name="1") 猜你喜欢
    .serch-word(v-if="pageScene==='duaring_search'&&form.feedbackModule==='0'") {{searchWord}}
    .guess-you-like(v-if="pageScene==='duaring_search'&&form.feedbackModule==='1'")
      .guess-you-like-item(v-for="(item,index) in legoList")
        .guess-you-like-info {{item.showText}}
    div.lable-title(v-if="form.feedbackModule==='1'&&pageScene==='duaring_search'")
      span 您不满意的词条是哪个?
    van-field.van-rate(v-if="form.feedbackModule==='1'&&pageScene==='duaring_search'"
      name="rate" label="" label-align="top")
      template(#input)
        div(style="width: 100%")
          van-checkbox-group.check-group(v-model="form.dissatisfiedContent"
            v-for="(item,index) in legoList")
            van-checkbox.from-check(:name="index" shape="square") {{item.showText}}
    div.lable-title(v-if="form.score>4&&pageScene==='duaring_search'")
      span.red-star *
      span 请问您最满意的地方是?
    van-field.van-rate(v-if="form.score>4&&pageScene==='duaring_search'"
    name="rate" label="" label-align="top" )
      template(#input)
        div
          van-checkbox-group(v-model="form.satisfiedIndex"
          v-for="(item,index) in duaringSearchGoodList")
            van-checkbox.from-check(:name="item.index" shape="square") {{item.value}}
    van-field.van-rate(
    v-if="pageScene==='duaring_search'&&gOther(duaringSearchGoodList,form.satisfiedIndex)&&form.score>4"
    name="rate" label="" )
      template(#input)
        van-field.border-color(v-model="form.otherDissatisfiedStatement"
        placeholder="说点什么吧" maxlength="100")
    div.lable-title(v-if="form.score<=4&&pageScene==='duaring_search'")
      span.red-star *
      span 请问您不满意的原因是什么?
    van-field.van-rate(v-if="form.score<=4&&pageScene==='duaring_search'"
      name="rate" label="" label-align="top")
      template(#input)
        div
          van-checkbox-group(v-model="form.dissatisfiedIndex"
          v-for="(item,index) in duaringSearchBadList")
            van-checkbox.from-check(:name="item.index" shape="square") {{item.value}}
    van-field.van-rate(
    v-if="pageScene==='duaring_search'&&gOther(duaringSearchBadList,form.dissatisfiedIndex)&&form.score<=4"
    name="rate" label="" )
      template(#input)
        van-field.border-color(v-model="form.otherDissatisfiedStatement"
        placeholder="说点什么吧" maxlength="100")
    div.lable-title(v-if="pageScene==='duaring_search'||pageScene==='search_result'")
      span 您对这个页面还有哪些意见或建议（选填）
    van-field.van-rate(v-if="pageScene==='duaring_search'||pageScene==='search_result'"
    name="rate" label="" label-align="top")
      template(#input)
        van-field.border-color(v-model="form.advice"
         placeholder="请留下您的宝贵建议，帮我我们提供更好的搜索..." maxlength="100")

    // 搜索联想词页面
    div.lable-title(v-if="form.score>4&&pageScene==='search_sug'")
      span.red-star *
      span 请选择您满意的原因
    van-field.van-rate(v-if="form.score>4&&pageScene==='search_sug'"
    name="rate" label="" label-align="top")
      template(#input)
        div
          van-checkbox-group(v-model="form.satisfiedIndex"
          v-for="(item,index) in searchSugGoodList")
            van-checkbox.from-check(:name="item.index" shape="square") {{item.value}}
    van-field.van-rate(
    v-if="pageScene==='search_sug'&&gOther(searchSugGoodList,form.satisfiedIndex)&&form.score>4"
    name="rate" label="" )
      template(#input)
        van-field.border-color(v-model="form.otherDissatisfiedStatement"
        placeholder="说点什么吧" maxlength="100")
    div.lable-title(v-if="form.score<=4&&pageScene==='search_sug'")
      span.red-star *
      span 请选择您不满意的原因?
    van-field.van-rate(v-if="form.score<=4&&pageScene==='search_sug'"
    name="rate" label="" label-align="top")
      template(#input)
        div
          van-checkbox-group(v-model="form.dissatisfiedIndex"
          v-for="(item,index) in searchSugBadList")
            van-checkbox.from-check(:name="item.index" shape="square") {{item.value}}
    van-field.van-rate(
    v-if="pageScene==='search_sug'&&gOther(searchSugBadList,form.dissatisfiedIndex)&&form.score<=4"
    name="rate" label="" )
      template(#input)
        van-field.border-color(v-model="form.otherDissatisfiedStatement"
        placeholder="说点什么吧" maxlength="100")
    div.lable-title(v-if="pageScene==='search_sug'")
      span 哪些联想词属于您想反馈的问题?
    van-field.van-rate(v-if="pageScene==='search_sug'" name="rate" label="" label-align="top")
      template(#input)
        div(style="width: 100%")
          van-checkbox-group.check-group(v-model="form.dissatisfiedContent"
            v-for="(item,index) in relationalWordList")
            van-checkbox.from-check(:name="index" shape="square") {{item}}
  .submit-btn(@click="onSubmit") 提交
</template>
<script>
import { Button } from 'vant';
import { legoData, uploadFeedBack } from '@/api/feedBack';
import { Native } from '@hb/NBridge/lib/h5';
import deepCopy from '@/utils/deepCopy';
import Toast from '@/components/toast';
import { getTokenAndLocation } from '../../utils/index';
import { ParamsUtil } from '../../utils/params';
import {
  searchResultValue, searchResultGood,
  searchResultBad, duaringSearchGood, duaringSearchBad, searchSugGood, searchSugBad,
} from './utils';

export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      form: {
        score: undefined,
        feedbackModule: undefined,
        satisfiedIndex: undefined,
        dissatisfiedIndex: undefined,
        dissatisfiedContent: undefined,
        advice: undefined,
        suitableIndex: undefined,
        satisfiedStatement: undefined,
        otherDissatisfiedStatement: undefined,
      },
      legoList: [],
      pageScene: '',
      relationalWordList: [],
      searchResultValueList: searchResultValue,
      searchResultGoodList: searchResultGood,
      searchResultBadList: searchResultBad,
      duaringSearchGoodList: duaringSearchGood,
      duaringSearchBadList: duaringSearchBad,
      searchSugGoodList: searchSugGood,
      searchSugBadList: searchSugBad,
      timer: null,
      searchWord: '',
      //  duaring_search:搜索中,search_sug:搜索联想词,search_result:搜索结果页
    };
  },
  created() {
    const { scene } = ParamsUtil.getParams(window.location.href);
    this.pageScene = scene;
  },
  async mounted() {
    try {
      const res = await Native.callNative({
        classMap: 'business/home',
        method: 'getPlatformSearchInfo',
      });
      if (res) {
        this.searchWord = res.searchWord;
        if (res.relationalWordList) {
          this.relationalWordList = res.relationalWordList;
        }
      }
      // eslint-disable-next-line no-console
      console.log('查看bridge数据', res);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('hb', e);
    }
    this.getLegoData();
  },
  beforeDestroy() {
    this.timer = null;
  },
  methods: {
    gOther(arr, value) {
      if (value) {
        if (value.includes(`${arr.length - 1}`)) {
          return true;
        }
        return false;
      }
      return false;
    },
    onChangeRate() {
      this.form.otherDissatisfiedStatement = undefined;
    },
    changeFeedbackModule() {
      this.form.dissatisfiedContent = undefined;
    },

    // eslint-disable-next-line consistent-return
    async onSubmit() {
      const subObj = deepCopy(this.form);
      if (Array.isArray(subObj.feedbackModule)) {
        subObj.feedbackModule = subObj.feedbackModule.join(',');
      }
      if (Array.isArray(subObj.satisfiedIndex)) {
        subObj.satisfiedIndex = subObj.satisfiedIndex.join(',');
      }
      if (Array.isArray(subObj.dissatisfiedIndex)) {
        subObj.dissatisfiedIndex = subObj.dissatisfiedIndex.join(',');
      }
      if (Array.isArray(subObj.dissatisfiedContent)) {
        subObj.dissatisfiedContent = subObj.dissatisfiedContent.join(',');
      }
      if (Array.isArray(subObj.suitableIndex)) {
        subObj.suitableIndex = subObj.suitableIndex.join(',');
      }
      if (Array.isArray(subObj.satisfiedStatement)) {
        subObj.satisfiedStatement = subObj.satisfiedStatement.join(',');
      }
      if (!subObj.score) {
        return Toast.show(' 亲，请填完全部内容再提交哦');
      } if (subObj.score > 4 && !subObj.satisfiedIndex) {
        return Toast.show(' 亲，请填完全部内容再提交哦');
      } if (subObj.score <= 4 && !subObj.dissatisfiedIndex) {
        return Toast.show(' 亲，请填完全部内容再提交哦');
      }
      if (subObj.score > 4) {
        subObj.dissatisfiedIndex = undefined;
        subObj.otherDissatisfiedStatement = undefined;
      } else {
        subObj.satisfiedIndex = undefined;
      }
      if (this.pageScene === 'search_result' && !subObj.suitableIndex) {
        return Toast.show(' 亲，请填完全部内容再提交哦');
      }
      const { token } = await getTokenAndLocation();
      try {
        const res = await uploadFeedBack({
          scene: this.pageScene,
          searchWord: this.searchWord,
          score: this.form.score,
          content: subObj,
          token,
        });
        if (res.data) {
          Native.closeWebView();
        } else {
          if (res.msg) {
            Toast.show(res.msg);
          } else {
            Toast.show('网络开小差');
          }

          this.timer = setTimeout(() => {
            Native.closeWebView();
          }, 2000);
        }
      } catch (e) {
        Toast.show('网络开小差');
        this.timer = setTimeout(() => {
          Native.closeWebView();
        }, 2000);
      }
    },
    async getLegoData() {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      try {
        const res = await legoData({
          pageCode: 'PLATFORM_SEARCH_SUGGESTION',
          token,
          originAdCode: adCode,
          originCityCode: cityCode,
          adCode,
          cityCode,
        });
        if (res.data) {
          res.data.forEach((item) => {
            if (item.moduleName === '搜索词推荐模块') {
              this.legoList = item.moduleData.businessList[0].items;
            }
          });
        }
      } catch (e) {
        // Toast.show('网络开小差');
        // this.timer = setTimeout(() => {
        //   Native.closeWebView();
        // }, 2000);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.feedback-container {
  padding: 0.12rem 0 0.2rem 0.2rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  font-weight: 400;
  color: #242729;
  background: #fff;

  .lable-title {
    color: #646566;
    font-size: 0.14rem;

    .red-star {
      color: red;
    }
  }

  .from-check {
    margin-bottom: 0.05rem;
  }

  .check-group {
    display: block;
    flex-wrap: wrap;
  }

  .guess-you-like {
    padding-top: 0.56rem;
    background-image: url(https://m.hellobike.com/resource/helloyun/08345/0mu9Enn5Gt.png);
    background-size: 100% 100%;
    width: 100%;
    height: 1.96rem;
    margin-left: -0.2rem;
    display: flex;
    justify-content: right;
    flex-wrap: wrap;
    text-align: center;

    .guess-you-like-item {
      width: 50%;
      height: 0.2rem;
    }
  }

  .serch-word {
    background-image: url(https://m.hellobike.com/resource/helloyun/08345/5-cJcreMQd.png);
    background-size: 100% 100%;
    width: 100%;
    height: 0.47rem;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #bcc4cc;
    padding-left: 0.84rem;
    line-height: 0.5rem;
    margin-left: -0.2rem;
  }
}

.submit-btn {
  margin: 0 auto;
  width: 2.32rem;
  height: 0.48rem;
  background: #08f;
  border-radius: 0.08rem;
  text-align: center;
  font-size: 0.18rem;
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  font-weight: 500;
  color: #fff;
  line-height: 0.48rem;
}

.total-page {
  background: #fff;
  padding-bottom: 0.2rem;
}

.border-color {
  margin-left: -0.1rem;
  border: 0.01rem solid #eee;
}

.van-cell::after {
  border-bottom: 0;
}

</style>
